export default __webpack_public_path__ + "static/media/MEETthin.881d0223.png";